import { ReactElement } from "react";
import useSetDatadogUser from "hooks/useSetDatadogUser";

const AnalyticsProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  useSetDatadogUser();
  return children;
};

export default AnalyticsProvider;
